export const featuredPortfolio = [
  {
    id: 1,
    title: "Terraform AWS Environment",
    type: "Infrastructure as Code",
    desc: "A multi-environment AWS infrastructure project using Terraform, VPCs, subnets, EC2, IAM, CloudWatch, S3 remote state and DynamoDB locking.",
    visual: "iac",
    link: "https://github.com/MarcMaslen",
  },
  {
    id: 2,
    title: "CI/CD Pipeline Automation",
    type: "DevOps automation",
    desc: "Automated build, test and deployment workflows with GitHub Actions and Bitbucket Pipelines, including Terraform plan/apply stages and approval gates.",
    visual: "pipeline",
    link: "https://github.com/MarcMaslen",
  },
  {
    id: 3,
    title: "AWS Lambda Automation Suite",
    type: "Serverless automation",
    desc: "Python and JavaScript Lambdas for resource cleanup, log rotation, notifications and scheduled/event-driven workflows with EventBridge.",
    visual: "lambda",
    link: "https://github.com/MarcMaslen",
  },
  {
    id: 4,
    title: "Matillion ETL to Data Productivity Cloud Migration",
    type: "Maia Foundation",
    desc: "Current specialist focus migrating Matillion ETL workloads into Data Productivity Cloud, with deep hands-on Maia Foundation experience.",
    visual: "data",
    link: "https://www.linkedin.com/in/marc-maslen-489b48189/",
  },
];

export const devopsPortfolio = [
  featuredPortfolio[0],
  featuredPortfolio[1],
  featuredPortfolio[2],
];

export const dataPortfolio = [
  featuredPortfolio[3],
  {
    id: 5,
    title: "Matillion & Snowflake ETL Optimisation",
    type: "Data engineering",
    desc: "Professional ETL work across Matillion, Snowflake, REST APIs, pipeline optimisation, orchestration improvements and production issue resolution.",
    visual: "data",
    link: "https://www.linkedin.com/in/marc-maslen-489b48189/",
  },
  {
    id: 6,
    title: "SQL Performance Reporting",
    type: "Analytics enablement",
    desc: "Built SQL-based reports for tracking validation, affiliate optimisation, and client decision-making during integration delivery.",
    visual: "reporting",
    link: "https://www.linkedin.com/in/marc-maslen-489b48189/",
  },
];

export const developmentPortfolio = [
  {
    id: 7,
    title: "React Portfolio Website",
    type: "Frontend",
    desc: "This portfolio, rebuilt as a professional CV-style site using React and SCSS.",
    visual: "frontend",
    link: "https://github.com/MarcMaslen",
  },
  {
    id: 8,
    title: "AI Search Methods",
    type: "Computer science",
    desc: "Heuristic search approaches for the 8-puzzle problem, kept as a concise example of algorithmic foundations.",
    visual: "algorithm",
    link: "https://github.com/MarcMaslen/AI-Search-Methods-for-the-8-Puzzle-Problem",
  },
  {
    id: 9,
    title: "Unity Tower Defence Project",
    type: "Final-year project",
    desc: "A larger university capstone combining game development, project delivery, and a supporting React website.",
    visual: "capstone",
    link: "https://github.com/MarcMaslen/Capstone-Project-2023",
  },
];

export const otherPortfolio = [
  {
    id: 10,
    title: "Blue Zero Web Designs",
    type: "Web design business",
    desc: "A web design business project that shows client-facing delivery, brand building, and early commercial web development experience.",
    visual: "bluezero",
    link: "http://www.bluezerowebdesigns.com",
  },
];
